<template>
    <fieldset class="compo-form-item">
        <div class="compo-form-name">
            <legend class="compo-form-title form-label-required">문의자정보</legend>
        </div>
        <div class="compo-form-body">
            <label class="visually-hidden" for="enquirerCompany">회사명</label>
            <input type="text" @blur="confirmVaildEnquirerCompany" v-model="enquirerCompany" id="enquirerCompany" placeholder="회사명" class="form-control">
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildEnquirerCompany">
                <p class="form-info" :class="{'active': messageVaildEnquirerCompany}">{{messageVaildEnquirerCompany}}</p>
            </template>
        </div>
        <div class="compo-form-body">
            <label class="visually-hidden" for="enquirerName">담당자명</label>
            <input type="text" @blur="confirmVaildEnquirerName" v-model="enquirerName" id="enquirerName" placeholder="담당자명" class="form-control">
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildEnquirerName">
                <p class="form-info" :class="{'active': messageVaildEnquirerName}">{{messageVaildEnquirerName}}</p>
            </template>
        </div>
        <div class="compo-form-body">
            <label class="visually-hidden" for="enquirerEmailAdress">이메일 주소</label>
            <input type="email" @blur="confirmVaildEmail" v-model="enquirerEmailAdress" id="enquirerEmailAdress" placeholder="이메일 주소" ref="enquirerEmailAdress" class="form-control">
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildEmail">
                <p class="form-info" :class="{'active': messageVaildEmail}">{{messageVaildEmail}}</p>
            </template>
        </div>
        <div class="compo-form-body">
            <label class="visually-hidden" for="enquirerPhoneNum">휴대폰 번호</label>
            <input type="tel" @keydown.stop="deleteCharacter" @blur="confirmVaildPhoneNum" v-model="enquirerPhoneNum" id="enquirerPhoneNum" placeholder="휴대폰 번호" ref="enquirerPhoneNum" class="form-control">
            <!-- 유효성 검사 메시지 -->
            <template v-if="messageVaildPhoneNum">
                <p class="form-info" :class="{'active': messageVaildPhoneNum}">{{messageVaildPhoneNum}}</p>
            </template>
        </div>
    </fieldset>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
    data() {
        return {
            enquirerCompany: '',                // 문의자 회사명
            enquirerName: '',                   // 문의 담당자명
            enquirerEmailAdress: '',            // 답변 받을 이메일 주소
            enquirerPhoneNum: '',               // 휴대폰 번호
            
            messageVaildEnquirerCompany: '',    // 문의자 회사명 유효성 검사 메시지
            messageVaildEnquirerName: '',       // 문의 담당자 유효성 검사 메시지
            messageVaildEmail: '',              // 이메일 주소 유효성 검사 메시지
            messageVaildPhoneNum: '',           // 휴대폰 번호 유효성 검사 메시지
        }
    },

    computed: {
        ...mapState({
            regExpEmail: state => state.bulkBuyingStore.regExpEmail,
            regExpMobile: state => state.bulkBuyingStore.regExpMobile,
        })
    },

    methods: {
        // Store
        ...mapMutations({
            setEnquirerCompany: 'bulkBuyingStore/setEnquirerCompany',
            setEnquirerName: 'bulkBuyingStore/setEnquirerName',
            setEnquirerEmailAdress: 'bulkBuyingStore/setEnquirerEmailAdress',
            setEnquirerPhoneNum: 'bulkBuyingStore/setEnquirerPhoneNum',
        }),
        
        // 회사명 필수값 유효성 검사
        confirmVaildEnquirerCompany(){
            if (!this.enquirerCompany) {
                this.messageVaildEnquirerCompany = '회사명을 입력해주세요.';
            }else{
                this.messageVaildEnquirerCompany = '';
            }
            this.setEnquirerCompany(this.enquirerCompany);
        },

        // 담당자명 필수값 유효성 검사
        confirmVaildEnquirerName(){
            if (!this.enquirerName) {
                this.messageVaildEnquirerName = '담당자 성함을 입력해주세요.';
            }else{
                this.messageVaildEnquirerName = '';
            }
            this.setEnquirerName(this.enquirerName);
        },

        // 이메일 유효성 검사
        confirmVaildEmail(){
            if (!this.regExpEmail.test(this.enquirerEmailAdress)) {
                this.messageVaildEmail = '이메일 주소를 양식에 맞게 입력해주세요.';
            }else{
                this.messageVaildEmail = '';
            }
            this.setEnquirerEmailAdress(this.enquirerEmailAdress);
        },

        // 휴대폰 유효성 검사
        confirmVaildPhoneNum(){
            if (!this.regExpMobile.test(this.enquirerPhoneNum)) {
                this.messageVaildPhoneNum = '휴대폰 번호를 양식에 맞게 입력해주세요.';
            }else{
                this.messageVaildPhoneNum = '';
            }

            this.setEnquirerPhoneNum(this.enquirerPhoneNum);
        },

        deleteCharacter(){
            if(this.enquirerPhoneNum){
                this.enquirerPhoneNum = this.enquirerPhoneNum.replace(/[^\d]/ig, ""); // 하이픈(-) 제거
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';
</style>